import { useEffect, useState } from 'react';
import {
    getSecondsSince,
    hoursMinutesSecondsSince,
    lessThanAnHourAgo,
    formatHms
} from '../shared/utilities.js'
import { useLanguage } from '../context/LanguageContext.js';
import { usei18n } from '../i18n/i18n.js';
import './BeenSince.css';

const beenSince = (timestamp, i18n) => {
    const [hours, minutes, seconds] = hoursMinutesSecondsSince(timestamp);
    if (hours >= 24) return <span className="a-long-time">{i18n('over24Hours')}</span>;

    return <span className="running-timer">{formatHms(hours, minutes, seconds)}</span>;
}

const BeenSince = ({ timestamp }) => {
    const [secondsSince, setSecondsSince] = useState(getSecondsSince(timestamp))
    const { language } = useLanguage();
    const i18n = usei18n(language);

    useEffect(() => {
        const timer = setTimeout(() => {
            setSecondsSince(getSecondsSince(timestamp))
        }, 1000)

        return () => {
            clearTimeout(timer);
        };
    }, [timestamp, secondsSince])

    const beenSinceFormatted = timestamp ? beenSince(timestamp, i18n) : <>&#8734;</>;
    const classes = `been-since-formatted-value ${lessThanAnHourAgo(timestamp) ? 'alert' : ''}`
    return (
        <div className="been-since">
            <p className={classes}>{beenSinceFormatted}</p>
            <p className="since-last">{i18n('sinceLastDose')}</p>
        </div>
    )
}

export default BeenSince
